<template>
  <div>
    <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:new="createHandler"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
        v-on:cancel="cancelHandler"
        v-on:delete="isConfirm = !isConfirm"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>

import HolidayAssignment from "../../../components/leave/holidayassignment/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": HolidayAssignment,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('setupholassigment.editholassigmentsetup'),
      pageTitleValue: "",
      formData: {
        grpvalueid: null,
        valuedesc: null,
        assignmentdetail: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    async loadHolidayAssignmentHandler() {
      const vm = this;

        try {  
          const res = await this.$store.dispatch('get', {url: "/holidayassignment/" + this.id})
        
          vm.formData = res.data.rec[0];

          vm.formData.grpvalueid = res.data.rec[0].grpvalueid;
          vm.formData.stamp = res.data.rec[0].stamp;
          vm.formData.lockstaff = res.data.rec[0].lockstaff;

          vm.formData.userid = this.$store.getters.userId;
          vm.pageTitleValue = res.data.rec[0].valuedesc;

          await this.loadHolidayAssignmentDetailHandler();

       //  vm.loading = false;
        }
        catch(err) {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        }
    },

    loadHolidayAssignmentDetailHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/holidayassignmentd/" + this.id})
        .then((res) => {
          vm.formData.assignmentdetail = res.data.rec;

          for (let i = 0; i < vm.formData.assignmentdetail.length; i++) {
            Object.assign(vm.formData.assignmentdetail[i], {
              action: 2,
            });
          }

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      this.$store.dispatch('put', {url: "/holidayassignment/" + vm.id,
          payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "holidayassignmentlist", params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          if (err.response && err.response.data) {
            vm.errMsg = err.response.data.message;//get error msg from server
          } else {
            vm.errMsg = err.message || err.toString() || "Unexpected Error Occurred.";
          }
        });
    },

    cancelHandler() {
      this.$router.push({ name: "holidayassignmentlist" });
    },

    deleteHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }

      this.$store.dispatch('delete', {url:
            "/holidayassignment/" +
            vm.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "holidayassignmentlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
      this.$router.push({ name: "holidayassignmentnew" });
    },
  },

  async mounted() {
    await this.loadHolidayAssignmentHandler();
  
  },
};
</script>